module.exports = __webpack_public_path__ + "static/img/nbfl.f0f48b76.png";